import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class CustomerInvoiceBillingCodeBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);

    }

    CID(): any {
        return this.customerInvoiceBillingCodeId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setFromForm(data: CustomerInvoiceBillingCodeBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    customerInvoiceBillingCodeId: string;
    billingCodeId: string;
    billingCode: string;
    customerId: string;
    locationId: string;
    rate: number;
    cost: number;
    description: string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
}